import { render, staticRenderFns } from "./DetailNew.vue?vue&type=template&id=d5087ce2&scoped=true&"
import script from "./DetailNew.vue?vue&type=script&lang=js&"
export * from "./DetailNew.vue?vue&type=script&lang=js&"
import style0 from "./DetailNew.vue?vue&type=style&index=0&id=d5087ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5087ce2",
  null
  
)

export default component.exports